<template>
  <div></div>
</template>

<script>
  import { playerStatuses } from '@/constants'

  export default {
    name: 'AudioPlayer',
    data: function () {
      return  {
        audio: new Audio(),
        currentTrackUrl: null,
        connectionType: null
      }
    },
    mounted: function () {
      this.audio.onended = () => {
        this.incrementTrackPlayCount()
        this.$store.commit('nextTrack')
      }

      if ('mediaSession' in navigator) {
        navigator.mediaSession.setActionHandler('play', _ => this.$store.commit('togglePlay'))
        navigator.mediaSession.setActionHandler('pause', _ => this.$store.commit('togglePlay'))
        navigator.mediaSession.setActionHandler('nexttrack', _ => this.$store.commit('nextTrack'))
        navigator.mediaSession.setActionHandler('previoustrack', _ => this.$store.commit('previousTrack'))
      }

      if ('connection' in navigator) {
        this.connectionType = navigator.connection.type

        navigator.connection.onchange = (event) => {
          this.connectionType = event.target.type
        }
      }
    },
    computed: {
      playerStatus: function () {
        return this.$store.state.playerStatus
      },
      isConnectionTypeCellular: function () {
        return this.connectionType === 'cellular'
      },
      currentTrackArtistNames: function () {
        return this.$store.getters.currentTrack.artists.map(
          (artist) => { return artist.name }
        ).join(", ")
      }
    },
    watch: {
      playerStatus: function (newPlayerStatus, oldPlayerStatus) {
        if (oldPlayerStatus === playerStatuses.PAUSED && newPlayerStatus === playerStatuses.PLAYING) {
          this.audio.play()
        }

        if (oldPlayerStatus === playerStatuses.PLAYING && newPlayerStatus === playerStatuses.PAUSED) {
          this.audio.pause()
        }

        if (newPlayerStatus === playerStatuses.STOPPED) {
          this.audio.pause()
          this.audio.src = null
          this.currentTrackUrl = null
        }
      },
      currentTrackUrl: function (newNextTrackUrl) {
        if (newNextTrackUrl) {
          this.audio.src = newNextTrackUrl

          if (this.playerStatus === playerStatuses.PLAYING) {
            this.audio.play()
            this.updateMediaSession()
          } else {
            this.audio.load()
            this.updateMediaSession()
          }
        }
      }
    },
    methods: {
      updateMediaSession: function () {
        if ('mediaSession' in navigator) {
          const currentTrack = this.$store.getters.currentTrack

          navigator.mediaSession.metadata = new MediaMetadata({
            title: currentTrack.name,
            artist: this.currentTrackArtistNames,
            album: currentTrack.album.name,
            artwork: [
              { src: currentTrack.album.cover.url }
            ]
          })
        }
      },
      incrementTrackPlayCount: function() {
        const currentTrackId = this.$store.getters.currentTrack.id

        this.$apollo.mutate({
          mutation: require('@/graphql/mutations/IncrementTrackPlayCount.gql'),
          variables: { trackId: currentTrackId }
        }).catch((error) => {
          console.warn(`Error trying to increment track play count with id ${currentTrackId}: ${error}`)
        })
      },
      selectSmallestSizeFile: function (trackFiles) {
        const selectedFile = trackFiles.reduce(
          (biggestFile, file) => {
            if (file.filesize < biggestFile.filesize) {
              return file
            } else {
              return biggestFile
            }
          },
          trackFiles[0]
        )

        return selectedFile
      },
      selectBiggestSizeFile: function (trackFiles) {
        const selectedFile = trackFiles.reduce(
          (biggestFile, file) => {
            if (file.filesize > biggestFile.filesize) {
              return file
            } else {
              return biggestFile
            }
          },
          trackFiles[0]
        )

        return selectedFile
      }
    },
    apollo: {
      currentTrackUrl: {
        query: require('@/graphql/TrackUrl.gql'),
        fetchPolicy: 'no-cache',
        variables () {
          return {
            trackId: this.$store.getters.currentTrack.id
          }
        },
        update (data) {
          if (this.isConnectionTypeCellular) {
            return this.selectSmallestSizeFile(data.track.files).url
          } else {
            return this.selectBiggestSizeFile(data.track.files).url
          }
        },
        skip () {
          return this.$store.getters.currentTrack == null
        }
      }
    }
  }
</script>
